import {Button, Card } from "react-bootstrap";
import ProjectModel from "../models/ProjectModel";
import './ProjectItem.css';
import {Fragment} from "react";
const ProjectItem = (props:any) => {
  const {id, title, description, techStack, demoLink, img } = props.project;
  return (
    <Card className="project-item">
      <Card.Img variant="top" src={img} style={{height: "300px", width:"400px"}}/>
      <Card.Body>
        <Card.Title>{title}</Card.Title>
        <Card.Text>
          <b>Description: </b>{description}
        </Card.Text>
        <Card.Text>
          <b>Tech Stack: </b>
          {techStack.map((item:string, index:number) => {
            if(index === techStack.length-1){
              return <Fragment key={item}>{` ${item}.`}</Fragment>
            } else {
              return <Fragment key={item}>{` ${item}, `}</Fragment>
            }
          })
          }
        </Card.Text>
        <button className="btn"><a href={demoLink}>Demo Link</a></button>
      </Card.Body>
    </Card>
  )
}

export default ProjectItem;